import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useRef, useState } from 'react';

// Original class: UserAvatarRoot
const StyledUserAvatarRoot = styled(Box)(theme => ({
  display: 'flex',
  alignItems: 'center',
}));
// Original class: avatar
const StyledAvatar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 32,
  minHeight: 32,
  maxWidth: 32,
  maxHeight: 32,
  borderRadius: theme.spacing(4),
  overflow: 'hidden',
  backgroundColor: '#37C670',
}));
const UserAvatar = ({
  avatar,
  userFirstName,
  userLastName,
  userFullNameArray,
  handleOpenAvatarMenu,
}) => {
  const userInitials = `${userFullNameArray[0][0]}${userFullNameArray[userFullNameArray.length - 1][0]}`;

  return (
    <StyledUserAvatarRoot onClick={handleOpenAvatarMenu}>
      <StyledAvatar>
        {avatar ? (
          <img src={avatar} alt='user avatar' />
        ) : (
          <Typography
            variant='h4'
            color='primary'
            sx={{
              fontWeight: 600,
            }}
          >
            {userInitials}
          </Typography>
        )}
      </StyledAvatar>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginLeft: 2,
        }}
      >
        <Typography
          variant='h5'
          color='primary'
          sx={{
            fontWeight: 600,
            lineHeight: '16px',
          }}
        >
          {userLastName}
        </Typography>
        <Typography
          variant='h6'
          color='primary'
          sx={{
            lineHeight: '14px',
          }}
        >
          {userFirstName}
        </Typography>
      </Box>
    </StyledUserAvatarRoot>
  );
};

export default UserAvatar;
